import tippy from 'tippy.js';
import { layer }  from '~/assets/icons/js/layer';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,  
            attributes:{
                "data-slg-type":"C-FORM-SWIPER-SLIDE"
            },
            classes: ['swiper-slide'],
            components: [
                {
                    tagName:'div',
                    classes:['form-group'],
                    components:[
                        {
                            type:"label",
                            content:"Label"
                        },
                        {
                            type:"input",
                            attributes:{
                                type:"text"
                            },
                            classes:['form-control']
                        },
                    ]
                },
                {
                    tagName:'div',
                    classes:['form-group'],
                    components:[
                        {
                            type:"label",
                            content:"Label"
                        },
                        {
                            type:"input",
                            attributes:{
                                type:"text"
                            },
                            classes:['form-control']
                        },
                    ]
                },
                {
                    tagName:'div',
                    classes:['form-group'],
                    components:[
                        {
                            type:'button',
                            attributes:{
                                type:"submit",
                                "data-slg-layer-control":"next"
                            },
                            classes:['btn','btn-primary'],
                            content:"Send"
                        }
                    ]
                }
            ]
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-FORM-SWIPER-SLIDE")
                return { type:'C-FORM-SWIPER-SLIDE' }
        }
    });

    var view = VIEW.extend({

    });

    DOMC.addType('C-FORM-SWIPER-SLIDE', {
      model:model,
      view:view,
    });

};
  